import React from "react";
import { Controller } from "../../../react-hook-form";
import { einMaxLength } from "../../../defines";
import { VeriInput } from "../VeriInput";
import { EinInputProps } from "./EinInput.types";

const EinInput: React.FC<EinInputProps> = ({
  inputProps,
  form,
  name,
  isRequired = true,
}) => {
  return (
    <Controller
      rules={{ required: isRequired ? "You must provide a EIN" : false }}
      render={({
        fieldState: { error },
        field: { onChange, value, name, ref },
      }) => (
        <VeriInput
          label="EIN"
          isRequired={isRequired}
          onChange={onChange}
          value={value || ""}
          ref={ref}
          name={name}
          maxLength={einMaxLength}
          optional={!isRequired}
          error={error?.message}
          {...inputProps}
        />
      )}
      control={form.control}
      name={name}
    />
  );
};

export default EinInput;
